import React from "react"

function IconArrowsSwitch({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="arrows-switch"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-arrows-switch"
      {...props}
    >
      <path
        d="m3.786 8.084 3.568 4.593H4.291a7.51 7.51 0 0 0 13.286 4.218l.82 1.055a8.819 8.819 0 0 1-15.419-5.274H.218l3.568-4.592zm7.993-4.777a8.817 8.817 0 0 1 8.8 8.265h2.76l-3.567 4.592-3.568-4.593h3.063A7.508 7.508 0 0 0 5.98 7.354l-.82-1.055a8.797 8.797 0 0 1 6.618-2.992z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconArrowsSwitch
